import {
  WSElement,
  WSEmptyState,
  WSGrid,
  WSList,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useProfitAndLossQuery } from "../components/ProfitAndLoss/useProfitAndLossQuery";
import { ProfitAndLossStatement } from "../components/ProfitAndLoss/ProfitAndLossStatement";
import { useTaxEstimateQuery } from "../components/ProfitAndLoss/useTaxEstimateQuery";
import { CardAddTransactions } from "../components/SidebarCards";
import { routeHelpersBookkeepingTab } from "../paths";

export const RouteBookkeepingProfitAndLoss: React.FC = () => {
  const { query, range } = useProfitAndLossQuery();
  const year = range.start.getFullYear();
  const queryTaxEstimate = useTaxEstimateQuery(year);
  const goToTab = routeHelpersBookkeepingTab.useGoTo();

  const renderContent = () => {
    if (query.isLoading) {
      return (
        <WSElement my="3XL">
          <WSLoader.Spinner />
        </WSElement>
      );
    }
    if (query.isError || !query.data) {
      return (
        <WSEmptyState
          type="error"
          title="Couldn't load profit & loss"
          description="Something went wrong. Please try again."
          actions={{
            buttons: [
              {
                label: "Try again",
                kind: "Secondary",
                onClick: () => {
                  void query.refetch();
                }
              }
            ]
          }}
        />
      );
    }
    return (
      <ProfitAndLossStatement
        data={query.data}
        taxEstimate={queryTaxEstimate.data}
        taxEstimateLoading={queryTaxEstimate.isLoading}
        year={year}
        onViewAllTransactions={() => goToTab({ tab: "transactions" })}
      />
    );
  };

  return (
    <WSGrid gutter="2XL">
      <WSGrid.Item span={{ xs: "12", m: "8" }}>
        <WSList gap="2XL">
          <WSText.Heading1>Profit & Loss</WSText.Heading1>
          {renderContent()}
        </WSList>
      </WSGrid.Item>
      <WSGrid.Item span={{ xs: "12", m: "4" }}>
        <CardAddTransactions />
      </WSGrid.Item>
    </WSGrid>
  );
};
